<template>
  <section class="fullwidth-product-ads" data-test-id="fullwidth-product-ads">
    <EMetaResults class="meta-results" data-test-id="meta-results" />
    <div>
      <EProductAdsCarousel
        :items="productAds"
        has-full-width-product-ads
        class="fullwidth-product-ads__carousel"
        data-test-id="fullwidth-product-ads-carousel"
        @ad-click="onAdClick(resultContainer.result)"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { privacyProxyMs } from '~~/common/js/constants/feature-flags';
import EMetaResults from '~/components/meta-results';
import EProductAdsCarousel from '~/components/product-ads/carousel';

export default {
  components: {
    EMetaResults,
    EProductAdsCarousel,
  },
  computed: {
    ...mapState(['productAds']),
    ...mapGetters('unleash', ['getFeatureToggle']),
    shouldProxyTracking() {
      return this.getFeatureToggle(privacyProxyMs.flag)?.value === privacyProxyMs.enabled;
    },
  },
  methods: {
    ...mapActions(['trackAdClick']),
    onAdClick({ pingSuffix }) {
      this.trackAdClick(pingSuffix, this.shouldProxyTracking);
    },
  },
};
</script>

<style lang="scss" scoped>
.fullwidth-product-ads__carousel {
  background-color: $white;
}
</style>
